// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login {
  line-height: 1.4;
  font-family: 'Fira Sans', sans-serif;
  color: var(--palette-text);
}

.Login__header {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 0 1.5rem 0;
  justify-content: space-between;
  background: var(--palette-thribee-white);
  color: var(--palette-gray-6);
}

.Login__headerLogo {
  flex: 1;
  margin-left: -0.5rem;
}

.Login__formWrapper {
  display: flex;
  width: 100%;
  align-items: center;
}

.Login__formWrapper div {
  flex: 1;
}

.Login__form {
  max-width: 24.5rem;
}

.Login__formTitle {
  font-size: 3.25rem;
  margin-bottom: 1.45rem;
  font-weight: 600;
  line-height: 1.15;
  margin-top: 122px;
}

.Login__formSubtitle {
  font-size: 1.45rem;
  max-width: 30rem;
  margin-bottom: 2.65rem;
}

.Login__formWrapper .ComputerImage {
  max-height: 35rem;
}

.Login__formWrapper .Login__Link {
  text-decoration: underline;
  color: var(--palette-text);
  display: block;
  margin-top: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.01rem;
  font-family: Roboto;
}

.Login__formWrapper .Button,
.Login__formWrapper .ButtonLink {
  margin-top: 2.5rem;
  font-weight: 500;
}

.Login__formWrapper .Input:first-of-type {
  margin-top: 1.21rem;
}

.Login__formWrapper .Input:not(:first-of-type) {
  margin-top: 1.5rem;
}

.Login__formWrapper .MessageCard {
  margin-top: 0.57rem;
}

.Login__family {
  background-color: #fef7e8;
  text-align: center;
  padding: 0;
  height: 247px;
}

.Login__familyLogos {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 700px;
  margin: 0 auto;
}

.Login__lifullLogo svg {
  height: 2.5rem;
}

.Login__lifullBrandsLogos {
  flex: 1;
  display: flex;
  height: auto;
  margin-left: 0;
  margin-top: 0;
}

.Login__lifullBrandsLogos div {
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.Login__lifullBrandsLogos svg,
.Login__lifullBrandsLogos svg path {
  fill: var(--palette-gray-8);
}

.Login__lifullBrandsLogos .NestoriaLogo {
  margin-top: 0.5rem;
}

.Login__lifullBrandsLogos .NuroaLogo {
  height: 4rem;
  margin-bottom: 0.6rem;
}

.Login__lifullBrandsLogos .NestoriaLogo,
.Login__lifullBrandsLogos .TrovitLogo {
  height: 2rem;
}

.Login__lifullBrandsLogos .MitulaLogo {
  height: 1.7rem;
}

.Login__familyTitle {
  font-size: 1.3rem;
  padding: 40px 0;
}

.Login__whatWeAre {
  text-align: center;
  padding: 1rem 0 4.5rem 0;
}

.Login__whatWeAreTitle {
  font-size: 2.15rem;
  margin: 2.15rem 0 3.35rem 0;
}

.Login__whatWeAreText {
  font-size: 1.15rem;
}

.Login__footer {
  border-top: 2px solid var(--unknown-grey-to-review-edf0f2);
  text-align: right;
  padding: 1rem 0;
}

.Login__footer a,
.Login__footer span {
  text-decoration: none;
  color: var(--palette-gray-6);
  margin-left: 0.5rem;
}

.Login__footer a:after {
  content: '·';
  margin-left: 0.5rem;
}

.Header,
.Login__formWrapper,
.Login__lifullLogosWrapper,
.Login__whatWeAre,
.Login__footerLinks {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.Login__formWrapper,
.Login__lifullLogos {
  margin-bottom: 3.2rem;
}

@media only screen and (max-width: 480px) {
  .Login__header  {
    padding: 2.5rem;
  }

  .Login__formWrapper {
    display: block;
    width: auto;
  }

  .Login__formTitle {
    padding: 0 2rem;
    font-size: 2rem;
    margin: 0;
  }

  .Login__formSubtitle{
    font-size: 1.15rem;
    padding: 1rem 2rem;
    margin: 0;
  }

  .Login__form {
    max-width: 24.5rem;
    padding: 0 2rem;
  }

  .Login__lifullBrandsLogos{
    flex-direction: column;
    padding: 0 0 1.5rem 0;
  }

  .Login__lifullBrandsLogos div {
    margin: .5rem 0;
    height: 40px;
    justify-content: center;
    flex: unset;
  }
  .Login__lifullBrandsLogos div a {
    display: flex;
  }

  .Login__family {
    height: auto;
  }

  .Login__familyTitle {
    padding: 2rem 0;
  }

  .Login__whatWeAre {
    padding: 0 0 2rem 0;
  }

  .Login__whatWeAreTitle {
    font-size: 2rem;
    padding: 2rem;
    margin: 0;
  }

  .Login__whatWeAreText {
    font-size: 1rem;
    padding: 0 2rem;
  }

  .Login__formImage {
    display: none;
  }

  .Login__footerLinks {
   display: flex;
    font-size: .7rem;
    justify-content: center;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./js/components/LoginLayout/LoginLayout.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;EAKE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;GACC,aAAa;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":[".Login {\n  line-height: 1.4;\n  font-family: 'Fira Sans', sans-serif;\n  color: var(--palette-text);\n}\n\n.Login__header {\n  display: flex;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2.5rem 0 1.5rem 0;\n  justify-content: space-between;\n  background: var(--palette-thribee-white);\n  color: var(--palette-gray-6);\n}\n\n.Login__headerLogo {\n  flex: 1;\n  margin-left: -0.5rem;\n}\n\n.Login__formWrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.Login__formWrapper div {\n  flex: 1;\n}\n\n.Login__form {\n  max-width: 24.5rem;\n}\n\n.Login__formTitle {\n  font-size: 3.25rem;\n  margin-bottom: 1.45rem;\n  font-weight: 600;\n  line-height: 1.15;\n  margin-top: 122px;\n}\n\n.Login__formSubtitle {\n  font-size: 1.45rem;\n  max-width: 30rem;\n  margin-bottom: 2.65rem;\n}\n\n.Login__formWrapper .ComputerImage {\n  max-height: 35rem;\n}\n\n.Login__formWrapper .Login__Link {\n  text-decoration: underline;\n  color: var(--palette-text);\n  display: block;\n  margin-top: 1.4rem;\n  font-weight: 500;\n  letter-spacing: 0.01rem;\n  font-family: Roboto;\n}\n\n.Login__formWrapper .Button,\n.Login__formWrapper .ButtonLink {\n  margin-top: 2.5rem;\n  font-weight: 500;\n}\n\n.Login__formWrapper .Input:first-of-type {\n  margin-top: 1.21rem;\n}\n\n.Login__formWrapper .Input:not(:first-of-type) {\n  margin-top: 1.5rem;\n}\n\n.Login__formWrapper .MessageCard {\n  margin-top: 0.57rem;\n}\n\n.Login__family {\n  background-color: #fef7e8;\n  text-align: center;\n  padding: 0;\n  height: 247px;\n}\n\n.Login__familyLogos {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.Login__lifullLogo svg {\n  height: 2.5rem;\n}\n\n.Login__lifullBrandsLogos {\n  flex: 1;\n  display: flex;\n  height: auto;\n  margin-left: 0;\n  margin-top: 0;\n}\n\n.Login__lifullBrandsLogos div {\n  flex: 1;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.Login__lifullBrandsLogos svg,\n.Login__lifullBrandsLogos svg path {\n  fill: var(--palette-gray-8);\n}\n\n.Login__lifullBrandsLogos .NestoriaLogo {\n  margin-top: 0.5rem;\n}\n\n.Login__lifullBrandsLogos .NuroaLogo {\n  height: 4rem;\n  margin-bottom: 0.6rem;\n}\n\n.Login__lifullBrandsLogos .NestoriaLogo,\n.Login__lifullBrandsLogos .TrovitLogo {\n  height: 2rem;\n}\n\n.Login__lifullBrandsLogos .MitulaLogo {\n  height: 1.7rem;\n}\n\n.Login__familyTitle {\n  font-size: 1.3rem;\n  padding: 40px 0;\n}\n\n.Login__whatWeAre {\n  text-align: center;\n  padding: 1rem 0 4.5rem 0;\n}\n\n.Login__whatWeAreTitle {\n  font-size: 2.15rem;\n  margin: 2.15rem 0 3.35rem 0;\n}\n\n.Login__whatWeAreText {\n  font-size: 1.15rem;\n}\n\n.Login__footer {\n  border-top: 2px solid var(--unknown-grey-to-review-edf0f2);\n  text-align: right;\n  padding: 1rem 0;\n}\n\n.Login__footer a,\n.Login__footer span {\n  text-decoration: none;\n  color: var(--palette-gray-6);\n  margin-left: 0.5rem;\n}\n\n.Login__footer a:after {\n  content: '·';\n  margin-left: 0.5rem;\n}\n\n.Header,\n.Login__formWrapper,\n.Login__lifullLogosWrapper,\n.Login__whatWeAre,\n.Login__footerLinks {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.Login__formWrapper,\n.Login__lifullLogos {\n  margin-bottom: 3.2rem;\n}\n\n@media only screen and (max-width: 480px) {\n  .Login__header  {\n    padding: 2.5rem;\n  }\n\n  .Login__formWrapper {\n    display: block;\n    width: auto;\n  }\n\n  .Login__formTitle {\n    padding: 0 2rem;\n    font-size: 2rem;\n    margin: 0;\n  }\n\n  .Login__formSubtitle{\n    font-size: 1.15rem;\n    padding: 1rem 2rem;\n    margin: 0;\n  }\n\n  .Login__form {\n    max-width: 24.5rem;\n    padding: 0 2rem;\n  }\n\n  .Login__lifullBrandsLogos{\n    flex-direction: column;\n    padding: 0 0 1.5rem 0;\n  }\n\n  .Login__lifullBrandsLogos div {\n    margin: .5rem 0;\n    height: 40px;\n    justify-content: center;\n    flex: unset;\n  }\n  .Login__lifullBrandsLogos div a {\n    display: flex;\n  }\n\n  .Login__family {\n    height: auto;\n  }\n\n  .Login__familyTitle {\n    padding: 2rem 0;\n  }\n\n  .Login__whatWeAre {\n    padding: 0 0 2rem 0;\n  }\n\n  .Login__whatWeAreTitle {\n    font-size: 2rem;\n    padding: 2rem;\n    margin: 0;\n  }\n\n  .Login__whatWeAreText {\n    font-size: 1rem;\n    padding: 0 2rem;\n  }\n\n  .Login__formImage {\n    display: none;\n  }\n\n  .Login__footerLinks {\n   display: flex;\n    font-size: .7rem;\n    justify-content: center;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
